import {DatePipe} from "@angular/common";
import {Provider} from "@angular/core";
import {I18nService} from "@app/core/i18n.service";
import {AudioPlayerService} from "@app/shared/components/audio-player-control/audio-player.service";
import {MinuteSecondsPipe} from "@app/shared/pipes/minute-seconds.pipe";
import {TimePipe} from "@app/shared/pipes/time.pipe";
import {EpisodesService} from "@app/shared/services/episodes.service";
import {FilesService} from "@app/shared/services/files.service";
import {MetricsService} from "@app/shared/services/metrics.service";
import {PodcastsService} from "@app/shared/services/podcasts.service";

import {CoyoPluginService} from "./coyo-plugin.service";

export const COYO_PLUGIN_PROVIDERS: Provider[] = [
  TimePipe,
  DatePipe,
  MinuteSecondsPipe,
  EpisodesService,
  PodcastsService,
  FilesService,
  MetricsService,
  AudioPlayerService,
  I18nService,
  CoyoPluginService,
];
